import React, {useEffect, useContext} from 'react'
import {
  Container,
  Button,
  Grid,
  Typography,
  Box,
  Card,
  TextField,
  CircularProgress,
  Drawer,
} from '@material-ui/core'
import WizardPreview from '../BarcodeWizardPreview'
import BarcodeNavHeaderButtons from '../BarcodeNavHeaderButtons'
import {Mutation} from 'react-apollo'
import {sendPdfRequest} from '../../graphql/barcode/mutations/sendPdfRequestMutation'
import TemplateDrawer from '../BarcodeNavHeaderButtons/BarcodeTemplateDrawer'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeLibraryReprint.styles'
import {BarcodeSheetRecordContext} from '../../context/BarcodeSheetRecord'
import {ToastMessageContext} from '../../context/ToastMessage'
import {UserContext} from '../../context/UserContext'
import {validateBarcodePermission} from '../../modules/common/utils/permissions'

export default function BarcodeLibraryReprint(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const {barcodeSheetRecord} = useContext(BarcodeSheetRecordContext)
  const accessToken = JSON.parse(window.localStorage.getItem('token'))
  const [nameError] = React.useState(false)
  const [barcodeSettingRecord, setBarcodeSettingRecord] = React.useState(
    props.location.state.barcodeData
  )

  const userId = parseInt(window.localStorage.getItem('user_id'))
  const userEmail = window.localStorage.getItem('user_email')
  const [disableOnChange] = React.useState(false)
  const [isNewDownload, setDownload] = React.useState(false)
  const [drawerOpen, setDrawerOpen] = React.useState(false)

  const [formValues, setFormValues] = React.useState({
    startPosition: '1',
    totalRepeat: '1',
    maxPosition: '1',
    startNumber: barcodeSettingRecord.startNumber,
    reprintEndNumber: barcodeSettingRecord.reprintEndNumber,
  })
  const toast = useContext(ToastMessageContext)
  const refBtnGenerate = React.useRef()
  const currentUser = React.useContext(UserContext)

  useEffect(() => {
    if (props.location.state.barcodeData !== barcodeSettingRecord) {
      setBarcodeSettingRecord(props.location.state.barcodeData)
    } else {
      if (window !== window.parent) {
        window.parent.postMessage('scrollTop', process.env.REACT_APP_BARCODE_WINDOW_URL)
      } else {
        window.scrollTo(0, 0)
      }
    }
  }, [props.location.state.barcodeData, barcodeSettingRecord])

  const handleChange = textField => event => {
    setFormValues({
      ...formValues,
      [textField]: event.target.value,
    })
  }

  const changePosition = (value, maxPosition) => {
    setFormValues({
      ...formValues,
      startPosition: value,
      maxPosition: maxPosition,
    })
  }

  function checkValidity() {
    let errorMessage = ''
    const start_number_original = barcodeSettingRecord.startNumber
    const end_number_original = barcodeSettingRecord.reprintEndNumber

    if (formValues.startPosition === '') {
      errorMessage = t('barcode.library.reprint-generate-automatic.start-position-blank')
    } else if (formValues.startPosition === '') {
      errorMessage = t('barcode.library.reprint-generate-automatic.start-position-blank')
    } else if (formValues.totalRepeat === '') {
      errorMessage = t('barcode.library.reprint-generate-automatic.total-repeat-blank')
    } else if (formValues.reprintEndNumber === '') {
      errorMessage = t('barcode.library.reprint-generate-automatic.end-number-blank')
    } else if (parseInt(formValues.startNumber) < 0) {
      errorMessage = t('barcode.library.reprint-generate-automatic.start-less-than')
    } else if (parseInt(formValues.reprintEndNumber) < 0) {
      errorMessage = t('barcode.library.reprint-generate-automatic.end-position-blank')
    } else if (
      parseInt(formValues.startNumber) < start_number_original ||
      parseInt(formValues.startNumber) > end_number_original
    ) {
      errorMessage =
        t('barcode.library.reprint-generate-automatic.start-greater-than') +
        start_number_original +
        t('barcode.library.reprint-generate-automatic.less-equal') +
        end_number_original
    } else if (
      parseInt(formValues.reprintEndNumber) > end_number_original ||
      parseInt(formValues.reprintEndNumber) < start_number_original
    ) {
      errorMessage =
        t('barcode.library.reprint-generate-automatic.end-greater-than') +
        start_number_original +
        t('barcode.library.reprint-generate-automatic.less-equal') +
        end_number_original
    } else if (parseInt(formValues.reprintEndNumber) < parseInt(formValues.startNumber)) {
      errorMessage = t('barcode.library.reprint-generate-automatic.end-start-greater')
    } else if (parseInt(formValues.startNumber) > parseInt(formValues.reprintEndNumber)) {
      errorMessage = t('barcode.library.reprint-generate-automatic.start-end-greater')
    } else if (parseInt(formValues.totalRepeat) > 5) {
      errorMessage = t('barcode.library.reprint-generate-automatic.repeat-equal')
    } else if (parseInt(formValues.totalRepeat) < 1) {
      errorMessage = t('barcode.library.reprint-generate-automatic.repeat-less-than')
    } else if (parseInt(formValues.startPosition) < 1) {
      errorMessage = t('barcode.library.reprint-generate-automatic.start-position-less-than')
    } else if (
      parseInt(formValues.startPosition) >
      barcodeSheetRecord.rows * barcodeSheetRecord.columns
    ) {
      errorMessage = t('barcode.library.reprint-generate-automatic.sheet-range')
    }

    if (errorMessage !== '') {
      toast.popMessage(errorMessage, 'error', refBtnGenerate.current)
      return false
    } else {
      return true
    }
  }

  function generatePdf(sendPdfRequest) {
    if(!validateBarcodePermission(currentUser, "can_generate")){
      return;
    }
    if (checkValidity()) {
      setDownload(true)
      sendPdfRequest({
        variables: {
          id: barcodeSettingRecord.id,
          accountId: barcodeSettingRecord.accountId,
          userId: userId,
          token: accessToken,
          userEmail: userEmail,
          barcodeLabelId: barcodeSettingRecord.barcodeLabelId,
          output: formValues.output,
          digits: parseInt(formValues.digits),
          prefix: formValues.prefix,
          startNumber: parseInt(formValues.startNumber),
          endNumber: parseInt(formValues.reprintEndNumber),
          totalRepeat: parseInt(formValues.totalRepeat),
          startPosition: parseInt(formValues.startPosition),
          dataSource: props.showTable === 'automated' ? 'automated' : 'from_objects',
          fieldId: props.showTable === 'automated' ? null : parseInt(formValues.field),
          entityId: props.showTable === 'automated' ? null : parseInt(formValues.group),
        },
      })
    }
  }

  function chooseTemplateBtn(event) {
    setDrawerOpen(true)
  }

  const toggleDrawer = open => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    setDrawerOpen(open)
  }

  return (
    <div>
      <BarcodeNavHeaderButtons
        previous={props.location.state.previous}
        template={barcodeSettingRecord}
      />

      <Grid container>
        <Grid item xs={6}>
          <Box marginTop={-8} />
          <Container>
            <Card>
              <Grid container>
                <Grid container item xs={8} justify="flex-start">
                  <Typography variant="h5">
                    <div className={classes.titleStyle}>
                      {t('barcode.library.reprint-generate-automatic.reprint-details')}
                    </div>
                  </Typography>
                </Grid>
                <Grid container item xs={4} justify="flex-end" margin="auto">
                  <Box marginTop={3} marginRight={3}>
                    <Button
                      color="primary"
                      className={classes.buttonLink}
                      onClick={chooseTemplateBtn}
                    >
                      {t('barcode.library.reprint-generate-automatic.choose-new')}
                    </Button>
                  </Box>
                </Grid>
                <Grid container justify="flex-start">
                  <div className={classes.descriptionStyle}>
                    {t('barcode.library.reprint-generate-automatic.sheet-template')}
                  </div>
                </Grid>
                <Grid container justify="flex-start">
                  <div className={classes.informationStyle}>{barcodeSettingRecord.sheet.name}</div>
                </Grid>

                <Grid container justify="flex-start">
                  <div className={classes.descriptionStyle}>
                    {t('barcode.library.reprint-generate-automatic.label-template')}
                  </div>
                </Grid>
                <Grid container justify="flex-start">
                  <div className={classes.informationStyle}>{barcodeSettingRecord.label.name}</div>
                </Grid>

                <Grid container item xs={12} justify="flex-start">
                  <Typography variant="h5">
                    <div className={classes.titleStyle}>
                      {t('barcode.library.reprint-generate-automatic.barcode-automatic')}
                    </div>
                  </Typography>
                </Grid>

                <Grid container>
                  <Grid container item xs={6}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {t('barcode.library.reprint-generate-automatic.name')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>{barcodeSettingRecord.name}</div>
                  </Grid>

                  <Grid container item xs={6}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {t('barcode.library.reprint-generate-automatic.type')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>
                      {barcodeSettingRecord.barcodeType}
                    </div>
                  </Grid>

                  <Grid container item xs={6}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {t('barcode.library.reprint-generate-automatic.label-template')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>
                      {barcodeSettingRecord.label.name}
                    </div>
                  </Grid>

                  <Grid container item xs={6}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {t('barcode.library.reprint-generate-automatic.digits')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>{barcodeSettingRecord.digits}</div>
                  </Grid>

                  <Grid container item xs={6}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {t('barcode.library.reprint-generate-automatic.prefix')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>
                      {barcodeSettingRecord.prefix
                        ? barcodeSettingRecord.prefix
                        : t('barcode.library.reprint-generate-automatic.none')}
                    </div>
                  </Grid>

                  <Grid container item xs={6}>
                    <Grid container>
                      <div className={classes.descriptionStyle}>
                        {t('barcode.library.reprint-generate-automatic.output')}
                      </div>
                    </Grid>

                    <div className={classes.informationStyle}>
                      {barcodeSettingRecord.output.toUpperCase()}
                    </div>
                  </Grid>

                  <Grid container item xs={6}></Grid>

                  <Grid container item xs={6} justify="flex-end" margin="auto">
                    <Grid container />
                  </Grid>
                </Grid>
              </Grid>
            </Card>

            <Grid container className={classes.textFieldStyle}>
              <Grid container item xs={3}>
                <TextField
                  id="start-number"
                  label={t('barcode.library.reprint-generate-automatic.start-number')}
                  value={formValues.startNumber}
                  fullWidth
                  type="number"
                  variant="outlined"
                  onChange={handleChange('startNumber')}
                  error={nameError}
                />
              </Grid>

              <Grid container item xs={1} />

              <Grid container item xs={3}>
                <TextField
                  id="reprint-end-number"
                  label={t('barcode.library.reprint-generate-automatic.end-number')}
                  type="number"
                  value={formValues.reprintEndNumber}
                  fullWidth
                  variant="outlined"
                  onChange={handleChange('reprintEndNumber')}
                  error={nameError}
                />
              </Grid>

              <Grid container item xs={1} />

              <Grid
                container
                item
                xs={4}
                justify="flex-end"
                hidden={barcodeSettingRecord.output === 'PNG'}
              >
                <TextField
                  id="start-position"
                  label={t('barcode.library.reprint-generate-automatic.start-sheet')}
                  value={formValues.startPosition}
                  fullWidth
                  type="number"
                  variant="outlined"
                  onChange={handleChange('startPosition')}
                  error={nameError}
                />
              </Grid>

              <Grid
                container
                item
                xs={7}
                className={classes.textFieldStyle}
                hidden={barcodeSettingRecord.output === 'PNG'}
              >
                <TextField
                  id="total-repeat"
                  label={t('barcode.library.reprint-generate-automatic.how-many')}
                  value={formValues.totalRepeat}
                  fullWidth
                  type="number"
                  variant="outlined"
                  onChange={handleChange('totalRepeat')}
                  disabled={disableOnChange}
                  error={nameError}
                />
              </Grid>
              <Grid container item xs={12} className={classes.textFieldStyle} justify="flex-end">
                <Mutation mutation={sendPdfRequest}>
                  {(sendPdfRequest, {loading, data}) => {
                    if (data && isNewDownload) {
                      setDownload(false)
                      if (
                        data.sendPdfRequest.errors.length === 1 &&
                        data.sendPdfRequest.pdfData.location.length > 0
                      ) {
                        window.location.href = `${data.sendPdfRequest.pdfData.location}`
                      } else {
                        toast.popMessage(
                          data.sendPdfRequest.errors[0],
                          'error',
                          refBtnGenerate.current
                        )
                      }
                    }

                    return (
                      <Button
                        onClick={e => generatePdf(sendPdfRequest)}
                        value="generate"
                        variant="contained"
                        color="primary"
                        disabled = {!validateBarcodePermission(currentUser, "can_generate")}
                        ref={refBtnGenerate}
                      >
                        {loading ? (
                          <div>
                            {t('barcode.library.reprint-generate-automatic.generating')}
                            <CircularProgress size={20} color="secondary" />
                          </div>
                        ) : (
                          t('barcode.library.reprint-generate-automatic.finish-generate')
                        )}
                      </Button>
                    )
                  }}
                </Mutation>
              </Grid>
            </Grid>
          </Container>
          <Box marginBottom={5} />
        </Grid>

        <Grid item xs={6}>
          <WizardPreview
            page="generate"
            barcodeStartPosition={formValues.startPosition}
            changePosition={changePosition}
            viewPNG={barcodeSettingRecord.output === 'PNG'}
          />
        </Grid>
      </Grid>
      <Drawer anchor="right" open={drawerOpen}>
        <TemplateDrawer
          toggleDrawer={toggleDrawer()}
          template={barcodeSettingRecord}
          reprint={true}
        />
      </Drawer>
    </div>
  )
}
